import React from "react";
import Icon from "@mdi/react";
import { mdiCheck } from "@mdi/js";
import { TIER_OPTIONS } from "../tierMeta";
import TierBadge from "./TierBadge";

interface Props {
  selected: string[];
  onToggle: (value: string) => void;
}

export default function TierCards({ selected, onToggle }: Props) {
  return (
    <div className="v2-tier-cards">
      {TIER_OPTIONS.map((option) => {
        const checked = selected.includes(option.value);

        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={checked}
            className={`v2-tier-card ${checked ? "is-active" : ""}`}
            onClick={() => onToggle(option.value)}
          >
            <span className="v2-tier-card__check" aria-hidden="true">
              {checked && <Icon path={mdiCheck} size="14px" />}
            </span>
            <TierBadge tier={option.value} />
            <span className="v2-tier-card__name">{option.name}</span>
          </button>
        );
      })}
    </div>
  );
}
